import React from 'react'
import { observer } from 'mobx-react'
import { ageBuckets } from 'constants.js'

const XAxisTick = ({ xScaleTranslate, pyramid }) => (
  <g
    className='tick' opacity='1'
    key={pyramid.age}
    transform={xScaleTranslate(pyramid)}
  >
    <line y2='6' />
    <text dy='18' dx='-4'>{ageBuckets.get(pyramid.age)}</text>
  </g>
)

export default observer(XAxisTick)
